import { render } from "./NewLookupKey.vue?vue&type=template&id=5d6b336f"
import script from "./NewLookupKey.vue?vue&type=script&lang=js"
export * from "./NewLookupKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__